export default function createDropdownPlaceholderFromId(id) {

    return '%.'+id+'.%';
    
}